import React from "react";
import { Button } from "components/common/Button";

type BannerButton = { label: string; onClick: () => void };

/// The line above an org's surfaces: the fact, then, for whoever can act on it,
/// one button to where they act. An alert has no dismiss; a warning is
/// something that will become one.
export const OrgBanner: React.FC<{
  tone?: "alert" | "warning" | "notice";
  children: React.ReactNode;
  action?: BannerButton;
  dismiss?: BannerButton;
  className?: string;
}> = ({ tone = "alert", children, action, dismiss, className }) => (
  <div
    className={["org-deletion-banner", tone !== "alert" && tone, className]
      .filter(Boolean)
      .join(" ")}
    role={tone === "alert" ? "alert" : "status"}
  >
    <div className="banner-dot" />
    <span className="flex-1">{children}</span>
    {action && (
      <Button
        variant="default"
        size="xs"
        className="button-active-state border-transparent!"
        onClick={action.onClick}
      >
        {action.label}
      </Button>
    )}
    {dismiss && (
      <Button variant="quiet-link" size="xs" onClick={dismiss.onClick}>
        {dismiss.label}
      </Button>
    )}
  </div>
);
